import { render } from "./AcademicYearsEditor.vue?vue&type=template&id=2adec1f7&scoped=true"
import script from "./AcademicYearsEditor.vue?vue&type=script&lang=js"
export * from "./AcademicYearsEditor.vue?vue&type=script&lang=js"

import "./AcademicYearsEditor.vue?vue&type=style&index=0&id=2adec1f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adec1f7"]])

export default __exports__